export default __webpack_public_path__ + "static/media/background2.72b7f345.png";